// /api/0/resource/create
import request from '../utils/request'
const { ocpSaasPath } = window.globalConfig

// 创建一条菜单
export function createMenu (params) {
    return request.post(`/${ocpSaasPath}/api/0/resource/create`, params)
}

// 删除菜单资源
export function deleteMenu (params) {
    return request.post(`/${ocpSaasPath}/api/0/resource/delete`, params)
}

// 更新菜单资源
export function editMenu (params) {
    return request.post(`/${ocpSaasPath}/api/0/resource/update`, params)
}